// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'
import { Header, Segment, Container, Button } from 'semantic-ui-react'
// react-router
import { Link } from 'react-router-dom'

// mobx
import { observable } from 'mobx'

// markdown parsing
import frontmatter from 'front-matter'
import Markdown from 'react-markdown/with-html'
import { downloadFile } from './self'
import { apiGatewayClient } from './api'
export const fragments = observable({})

loadHtml2('/custom-content/content-fragments/GettingStarted.md', 'GettingStarted')
loadHtml2('/custom-content/content-fragments/APIs.md', 'APIs')
loadHtml2('/custom-content/content-fragments/B2BGateway.md', 'B2BGateway')
loadHtml2('/custom-content/content-fragments/FAQ.md', 'FAQ')
loadHtml2('/custom-content/content-fragments/TermsAndConditions.md', 'TermsAndConditions')
generateHome('Home');

/**
 * Pre-load custom-content markdown via the API Gateway client (HTTPS), parse
 * frontmatter, and store the rendered JSX on the MobX fragments observable.
 *
 * @param {String} path   Path to the markdown file.
 * @param {String} fragment   Name of the fragment store key.
 */
function loadHtml2(path, fragment) {
  // if we want to display a loading indicator, this would be where
  fragments[fragment] = { jsx: () => null }
  console.log("html2 path" +  path)
  apiGatewayClient()
    .then(client => client.get(path, {}, {}, {}))
    .then(response => {
      let text = response.data;
      let parsedMarkdown = frontmatter(text)

      fragments[fragment] = {
        jsx: () => (
          <Markdown
            escapeHtml={false}
            source={parsedMarkdown.body}
            renderers={renderers}
          />
        ),
        ...parsedMarkdown.attributes
      }
    })
    .catch(err => console.error(`Failed to load content fragment '${fragment}' from ${path}:`, err));
}

function generateHtml(fragment, text) {
  let parsedMarkdown = frontmatter(text)

  fragments[fragment] = {
    jsx: () => (
      <Markdown
        escapeHtml={false}
        source={parsedMarkdown.body}
        renderers={renderers}
      />
    ),
    ...parsedMarkdown.attributes
  }
}

function generateHome(fragment) {
  const homeMarkdown = `---
title: Developer Portal
header: Welcome to Helia Developer Portal
tagline: Your digital gateway to Helia.
gettingStartedButton: Get started
apiListButton: Our APIs
---

### Explore and build

Sign in to:

* Test against our live APIs using swagger-like functionality.
* Download json samples or our "Postman" collection and environment.
* Monitor your API usage.
* Retrieve your API Key.
* Read more about our APIs in our quick start and reference documentation.

To request a login, please send an email to api.support.au@helia.com.au with the following details:

* Your name.
* The organisation you are setting up the account for.
* The email address to be used for the username.
* A contact phone number (to be used during the setup process only if necessary).
`;

  generateHtml(fragment, homeMarkdown);
}

/**
 * Renderers is a map of node type to component. 
 * 
 * In this case, we only override links. Any time react-markdown tries to render a link, it'll render this component. Normal links will work, but the cause a full page reload. We don't want that, so we can replacing them with react-router Links. However, replacing external links with react-router Links causes them to not work at all. We don't want that either, so we attempt to determine if a link is external or not, and use `Link` or `a` appropriately.
 */
const renderers = {
  link: ({ href, ...props }) => {
    // if absolute url, use an `a` tag
    // https://stackoverflow.com/a/19709846/4060061
    if (/^(?:[a-z]+:)?\/\//i.test(href))
      return <a href={href} target="_blank" rel="noopener noreferrer" {...props} />
    
    // replace links with react-router-dom tags so that they 
    if (href.indexOf(".")==-1 && href.indexOf("@")!=-1)
      return <Link to={href} {...props} />
    let name = props.children[0].props.children;
    return <Link onClick={() => downloadFile(href)} to='#' > {name} </Link>
    
  }
}